/**
 * ESPN scoreboard "dates" param uses US sports-day (Eastern), not UTC.
 * Azure API defaults to UTC and misses evening NBA/NHL games on prod.
 */
export function formatSportsScoreboardDate(date = new Date(), timeZone = 'America/New_York') {
  return new Intl.DateTimeFormat('en-CA', { timeZone }).format(date).replace(/-/g, '');
}

/** Today and yesterday in US Eastern — covers late games after midnight ET. */
export function getSportsScoreboardDates(date = new Date()) {
  const today = formatSportsScoreboardDate(date);
  const yesterdayDate = new Date(date);
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  const yesterday = formatSportsScoreboardDate(yesterdayDate);
  return yesterday === today ? [today] : [today, yesterday];
}
